import { createAction } from 'redux-api-middleware';
import { getToken } from '../utils/auth';
import { downloadOrOpenBlob } from '../utils/download';
import { handleError } from '../utils';

export const FETCH_ATTACHMENT_REQUEST = 'FETCH_ATTACHMENT_REQUEST';
export const FETCH_ATTACHMENT_SUCCESS = 'FETCH_ATTACHMENT_SUCCESS';
export const FETCH_ATTACHMENT_FAILURE = 'FETCH_ATTACHMENT_FAILURE';
export const UPLOAD_ATTACHMENT_REQUEST = 'UPLOAD_ATTACHMENT_REQUEST';
export const UPLOAD_ATTACHMENT_SUCCESS = 'UPLOAD_ATTACHMENT_SUCCESS';
export const UPLOAD_ATTACHMENT_FAILURE = 'UPLOAD_ATTACHMENT_FAILURE';
export const DELETE_ATTACHMENT_REQUEST = 'DELETE_ATTACHMENT_REQUEST';
export const DELETE_ATTACHMENT_SUCCESS = 'DELETE_ATTACHMENT_SUCCESS';
export const DELETE_ATTACHMENT_FAILURE = 'DELETE_ATTACHMENT_FAILURE';

/**
 * Fetch single attachment related to a contract.
 *
 * @param {string} address - Contract address.
 * @param {string} file - Attachment document name.
 * @param {string} open - open in a new tab if true, otherwise trigger download
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const fetchAttachment = (contractAddress, file, open = false) =>
  createAction({
    endpoint: `${window.config.apiUrl}/contracts/${contractAddress}/attachments/${file.documentName}?documentType=${file.documentType}&attachmentId=${file?.attachmentId}`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/octet-stream',
      'Content-Disposition': `attachment; filename=${file.documentName}`,
    },
    types: [
      { type: FETCH_ATTACHMENT_REQUEST },
      {
        type: FETCH_ATTACHMENT_SUCCESS,
        payload: async (action, state, res) => {
          const blob = await res.blob();
          downloadOrOpenBlob(blob, file.documentName, open);
        },
      },
      { type: FETCH_ATTACHMENT_FAILURE },
    ],
  });

export const fetchAttachmentFromUrl = (url, fileName = '', open = false) =>
  createAction({
    endpoint: url,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/octet-stream',
      'Content-Disposition': `attachment; filename=${fileName}`,
    },
    types: [
      { type: FETCH_ATTACHMENT_REQUEST },
      {
        type: FETCH_ATTACHMENT_SUCCESS,
        payload: async (action, state, res) => {
          const blob = await res.blob();
          downloadOrOpenBlob(blob, fileName, open);
        },
      },
      { type: FETCH_ATTACHMENT_FAILURE },
    ],
  });

export const uploadAttachment = (files, contractAddress, documentType) => {
  const formData = new FormData();
  formData.append('file', files[0]);
  formData.append('documentType', files[0].type);

  return createAction({
    endpoint: `${window.config.apiUrl}/contracts/${contractAddress}/attachments?documentType=${documentType}`,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    body: formData,
    options: {
      isFileUpload: true,
    },
    types: [
      {
        type: UPLOAD_ATTACHMENT_REQUEST,
      },
      {
        type: UPLOAD_ATTACHMENT_SUCCESS,
      },
      {
        type: UPLOAD_ATTACHMENT_FAILURE,
        payload: handleError,
      },
    ],
  });
};

export const deleteAttachment = (contractAddress, file) => {
  const { documentName, documentType } = file;
  return createAction({
    endpoint: `${window.config.apiUrl}/contracts/${contractAddress}/attachments?documentType=${documentType}`,
    method: 'DELETE',
    body: JSON.stringify({ documentName }),
    types: [
      { type: DELETE_ATTACHMENT_REQUEST },
      {
        type: DELETE_ATTACHMENT_SUCCESS,
      },
      { type: DELETE_ATTACHMENT_FAILURE, payload: handleError },
    ],
  });
};
